import clsx from 'clsx';
import { forwardRef } from 'react';

import type { DataTestId } from '../../types/data-props.js';
import type { DOMProps } from '../../types/dom.js';
import type { StylingProps } from '../../types/styling-props.js';
import type { WithChildren } from '../../types/with-children.js';
import * as styles from './VisuallyHidden.sty.js';

/**
 * Props for the VisuallyHidden component.
 * @internal
 */
export type VisuallyHiddenProps = WithChildren &
  DataTestId &
  StylingProps &
  DOMProps;

/**
 * Element with styles that visually hides the contents.
 * @internal
 */
export const VisuallyHidden = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  VisuallyHiddenProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
    ...remainingProps
  }: VisuallyHiddenProps = props;

  return (
    <div
      ref={forwardedRef}
      className={clsx(consumerClassName, styles.visuallyHidden)}
      style={consumerStyle}
      data-testid={dataTestId}
      {...remainingProps}
    >
      {children}
    </div>
  );
});
